export class VaultMetadataReplicationConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "replicationBucketId",
            "baseName": "replicationBucketId",
            "type": "string",
            "format": ""
        },
        {
            "name": "replicationPrefix",
            "baseName": "replicationPrefix",
            "type": "string",
            "format": ""
        },
        {
            "name": "replicationRegion",
            "baseName": "replicationRegion",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return VaultMetadataReplicationConfig.attributeTypeMap;
    }
    constructor() {
    }
}
